module.exports = __webpack_public_path__ + "img/clc_clgguilde.gm.4e445da.png";